import {ACCESS_TOKEN, BASE_OAUTH_REDIRECT_URL, GOOGLE_OAUTH_REDIRECT_URI, REFRESH_TOKEN, UPSTOX_OAUTH_REDIRECT_URI, X_OAUTH_REDIRECT_URI} from "../assets/constants";
import {jwtDecode} from "jwt-decode";
import {User} from "../proto/generated/identity";

/** True when a non-expired access JWT is present (independent of refresh token). */
export const isAccessTokenValid = (): boolean => {
    try {
        const token = localStorage.getItem(ACCESS_TOKEN)
        if (!token) return false
        const decoded = jwtDecode<{ exp?: number }>(token)
        return !!(decoded.exp && decoded.exp > Math.ceil(Date.now() / 1000))
    } catch {
        return false
    }
}

export const isAuthenticated = (): boolean => {
    try {
        const token = localStorage.getItem(ACCESS_TOKEN)
        const refresh = localStorage.getItem(REFRESH_TOKEN)
        if (token !== null) {
            const decoded = jwtDecode<{ exp?: number }>(token)
            if (decoded.exp && decoded.exp > Math.ceil(Date.now() / 1000)) {
                return true
            }
        }
        if (refresh) {
            return true
        }
        if (token !== null) {
            localStorage.removeItem(ACCESS_TOKEN)
        }
        return false
    } catch {
        return !!localStorage.getItem(REFRESH_TOKEN)
    }
}
export const isAdmin = (user: User | null): boolean => {
        return !!user?.authorities?.some(auth => auth.toLowerCase() === "admin");
};

export const getRedirectUrl = (provider: string): string => {
    switch (provider) {
        case 'X':
            return X_OAUTH_REDIRECT_URI!
        case 'GOOGLE':
            return GOOGLE_OAUTH_REDIRECT_URI!
        case 'UPSTOX':
            return UPSTOX_OAUTH_REDIRECT_URI!
        default:
            return BASE_OAUTH_REDIRECT_URL!
    }
}